<template>
    <div>
      <el-button :type="btnType" size="medium" round @click="clickBtn" >{{btnContent}}</el-button>

      <!-- 弹框 -->
      <el-dialog :title="title"
                 :visible="dialogVisible"
                 :width="controlWidth"
                 @close="onClose"
                 :modal-append-to-body="false"
                 :close-on-click-modal="false"
                 :close-on-press-escape="false">
        <div class="dialog-content" v-loading="loading">
          <!--价位选择-->
          <ul>
            <li v-for="(item,index) in moneyList" :key="index" @click="choose(item)" :class="item.active ? 'active' : ''">
              <p>
                <i class="el-icon-s-finance"></i>
                <b>{{item.money}}</b>
              </p>
              <span>￥{{ formatDecimal(item.money / (1 - (PaymentType == 1 ? 0 : fee))) }}</span>
            </li>
            <li @click="chooseLast()" :class="last.active ? 'active' : ''">
              <p>
                <i class="el-icon-s-finance"></i>
                <b><el-input type="text" v-model="last.money" style="width: 100px;"
                  oninput="if(isNaN(value) || value > 20000) { value = null } if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+3)}"></el-input></b>
              </p>
              <span>￥{{ formatDecimal(last.money / (1 -(PaymentType == 1 ? 0 : fee))) }}</span>
            </li>
          </ul>
          <div class="section">
            <span>应支付手续费：</span>
            <p style="color: #555; font-size: 18px">
              <span v-if="PaymentType == 1" style="text-decoration: line-through; margin-right: 10px;"> ￥{{ formatDecimal(money / (1 - fee) - money)}} </span>
              ￥{{ PaymentType == 1 ? 0 : formatDecimal(money / (1 - fee) - money) }}</p>
          </div>
          <!--应付金额-->
          <div class="section">
            <span>应付总金额：</span>
            <p> <span v-if="PaymentType == 1" style="text-decoration: line-through; margin-right: 10px;"> ￥{{ toFixed(money / (1 -fee)) }} </span> ￥{{ theMoney }}</p>
          </div>
          <!--支付方式-->
          <div class="section" v-if="bank == 'abc'">
            <span>支付方式：</span>
            <el-radio-group v-model="PaymentType">
              <el-radio :label="1" border size="mini">农业银行卡支付</el-radio>
              <el-radio :label="6" border size="mini">他行银联卡支付</el-radio>
            </el-radio-group>
          </div>
          <div class="section" v-if="bank == 'unionpay'">
            <span>支付方式：</span>
            <el-radio-group v-model="PaymentType">
              <el-radio :label="6" border size="mini">银联在线支付</el-radio>
            </el-radio-group>
          </div>
          <div class="section" v-if="bank == 'icbcpay'">
            <span>支付方式：</span>
            <el-radio-group v-model="PaymentType">
              <el-radio :label="0" border size="mini">工行银行卡支付</el-radio>
            </el-radio-group>
          </div>
          <div class="section" v-else>

          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button v-if="bank == 'nojumpunionpay'" type="success" @click="toPayNew"> 立即支付 </el-button>
          <el-button v-else-if="bank == 'icbcpay'" type="success" @click="toPayGH"> 立即支付 </el-button>
          <pay-button v-else ref="payButton" @onpay="onpay" @beforePay="beforePay" :url="url.pay" :PayAmout="theMoney"
           :paymentType="PaymentType"
           @cannotpay="onCannotpay" type="success" :disabled="loading || theMoney <= 0">立即支付</pay-button>
        </span>
      </el-dialog>
    </div>
</template>

<script>
  import PayButton from '@/components/Buttons/PayButton'

    export default {
      components: {
        PayButton
      },
      props: {
        btnType: {
          type: String
        },
        btnContent: {
          type: String
        },
        title: {
          type: String
        },
        width: {
          type :String,
          default: '400px'
        },
        moneyList:{
          type: Array
        },
        selectMoney: {
          type: Number
        }
      },
      data() {
        return {
          last: {
            active: false,
            money: 0,
            coolMoney: 0
          },
          fee: 0,
          bank: "unionpay",
          PaymentType: 1,
          dialogVisible:false,
          loading: false,
          money:10,
          url:{
            pay: SZH.assets.api + "/UnionPay/Pay",
            getCardInfo: SZH.assets.api + "/Custom/GetCustomBankCardInfo",
            checkStatusUrl: SZH.assets.api + "/UnionPay/CheckOpenStatus",
          },
          infoMessage:'正在获取银行卡相关信息...'
        }
      },
      methods: {
        onCannotpay() {
          this.loading = false;
        },
        beforePay() {
          this.loading = true;
        },
        onpay(id) {
          this.loading = false;
          this.dialogVisible = false;
          this.$emit('onpay', id)
        },
        toFixed(val) {
          return parseFloat(val).toFixed(2);
        },
        clickBtn(){
          this.$confirm('请确保充值银行卡与账号绑定银行卡一致，持卡人与身份证一致，如因银行卡或身份不一致的情况造成的钱款无法退回，本公司概不负责，您确定要充值定金券吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
            center: true
          }).then(() => {
            this.$emit('clickBtn');
            var find = false;
            for(var i = 0;i<this.moneyList.length;i++){
              if(this.moneyList[i].active == true){
                this.money = this.moneyList[i].money;
                find = true;
                break;
              }
            }
            if(!find) {
              this.money = this.selectMoney;
              this.last.active = true;
              this.last.money = this.selectMoney;
            }
            this.dialogVisible = true;
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消充值'
            });
          });

        },
        onClose() {
          this.dialogVisible = false;
        },
        chooseLast() {
          if(!this.last.active) {
            for(var i in this.moneyList){
              this.moneyList[i].active = false;
            }
            this.last.active = true;
            this.money = this.last.money;
          }
        },
        choose(val){
          this.last.active = false;
          for(var i in this.moneyList){
            this.moneyList[i].active = false;
            if(this.moneyList[i].money == val.money){
              this.moneyList[i].active = true;
            }
          }
          this.money = val.money;
        },
        // 支付
        toPay(){
          this.$emit('toPay')
        },
        payAgain(){
          this.$refs['payButton'].pay();
        },
        formatDecimal(num) {
          num = num.toString();
          let index = num.indexOf('.');
          if (index !== -1) {
            num = num.substring(0, 2 + index + 1)
          } else {
            num = num.substring(0)
          }
          return parseFloat(num).toFixed(2)
        },
        //无跳转支付
        toPayNew(){
          let self =this;
          const loading = self.$loading({
            lock: true,
            text: self.infoMessage,
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
          self.$http.post(self.url.getCardInfo,{

          }).then(result =>{
            if(result.State == 1){
                // loading.close();
                self.infoMessage = '正在验证是否开通无跳转支付....';
                self.checkStatus(result.Data,loading);
            }else{

              loading.close();
            }
          }, () => {
            loading.close();
            self.$message.error('数据保存失败，请检查您的网络是否可用。');
          });
        },
        //工行卡支付
        toPayGH(){
          this.$message.success('工行卡支付....')
        },
        checkStatus(info,load){
          let self =this;

          self.$http.post(self.url.checkStatusUrl,{
            Data:{
              AccNo:info.Account
            }
          }).then(result =>{
            if(result.State == 1){
              self.$router.push({
                path:'/CheckToPay',
                query:{
                  info:this.$Base64.encode(JSON.stringify({
                    AccNo: info.Account,
                    Phone:info.PhoneNumber,
                    moneyDad:info.Enterprise,
                    money:self.formatDecimal((this.money / (1 -this.fee)))
                  }))
                }
              });
              load.close();
            }else if(result.State == 9){
              self.$notify.error({
                title: '错误',
                message: result.Message
              });
              load.close();
            }else{
              self.$router.push({
                path:'/CheckPay',
                query:{
                  info:this.$Base64.encode(JSON.stringify({
                    AccNo: info.Account,Phone:info.PhoneNumber
                  }))
                }
              });
            }
          }, () => {
            self.$message.error('数据保存失败，请检查您的网络是否可用。');
          });

        }
      },
      mounted(){
        this.bank = SZH.bank;
        console.log(this.bank);
        if(this.bank == 'abc') {
          this.PaymentType = 1;
        }else if(this.bank == 'nojumpunionpay') {
          this.PaymentType = 6;
        }else{
          this.PaymentType = 6;
        }
        this.fee = SZH.bankfee;
      },
      computed: {
        controlWidth(){
          return this.width
        },
        theMoney() {
          return parseFloat(this.PaymentType == 6 ? this.formatDecimal((this.money / (1 -this.fee))): this.money)
        }
      },
      watch: {
        dialogVisible(val) {
          if(!val) {
            for(var i in this.moneyList){
              this.moneyList[i].active = false;
            }
            this.last = {
              active: false,
              money: 0,
              coolMoney: 0
            }
          }
        },
        'last.money'(val) {
          this.chooseLast();
          this.last.money = val;
          this.money = val;
        }
      }
    }
</script>

<style scoped>
  button{width: 100%;}
  .dialog-content{
    width: 100%;
  }
  .dialog-content ul{
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    margin-bottom: -12px;
    justify-content: space-around;
  }
  .dialog-content ul li{
    width: 156px;
    height: 96px;
    margin-bottom: 12px;
    border: 1px solid #ddd;
    text-align: center;
    border-radius: 4px;
    cursor: pointer;
  }
  .dialog-content ul li.active{
    border: 2px solid #0a529c;
  }
  .dialog-content ul li.active span{
    color: #0a529c;
  }
  .dialog-content ul li p{
    font-size: 24px;
    height: 57px;
    line-height: 57px;
  }
  .dialog-content ul li p i{
    color: #0a529c;
  }
  .dialog-content ul li>span{
    background: #eeeeee;
    display: inline-block;
    width: 100%;
    height: 35px;
    line-height: 35px;
  }
  .dialog-content .section{
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
  }
  .dialog-content .section span{
    font-size: 14px;
    color: #999;
    line-height: 20px;
  }
  .dialog-content .section p{
    font-size: 24px;
    color: #ff4081;
    line-height: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dialogs/DialogButton.vue